import React from 'react'
import { Typography } from '@material-ui/core'
import clsx from 'clsx'

import { useStyles } from './SectionBlock.style'

const SectionBlock = ({ children, title, className, titleClassName }) => {
  const classes = useStyles()

  return (
    <div className={clsx(classes.container, className)}>
      <div className={classes.titleContainer}>
        <Typography variant='h3' className={clsx(classes.title, titleClassName)} id='sectionTitle'>
          {title}
        </Typography>
      </div>

      {children}
    </div>
  )
}

export default SectionBlock
